import { Grid, InputLabel, TextField, Typography } from "@mui/material";
import React from "react";
import DOMPurify from "dompurify";
import WysiwygEditor from "../../../../components/MarkdownEditor/WysiwygEditor";
import { addBreadcrumb } from "../../../../config/sentry";

const ActivityBasicDetails = ({ formik, mode, videoUrlWarning }) => {
  const hasVideoUrlError =
    formik.touched.video_url && Boolean(formik.errors.video_url);
  const showVideoUrlWarning =
    !hasVideoUrlError && !!videoUrlWarning;
  return (
    <>
      <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
        <Grid item xs={5} sx={{ textAlign: "right" }}>
          <InputLabel>Name</InputLabel>
        </Grid>
        <Grid item xs={7}>
          <TextField
            variant="outlined"
            fullWidth
            value={formik.values.title}
            onChange={(e) => formik.setFieldValue("title", e.target.value)}
            onBlur={formik.handleBlur}
            error={formik.touched.title && Boolean(formik.errors.title)}
            helperText={formik.touched.title && formik.errors.title}
            InputProps={{
              readOnly: mode === "view",
            }}
            inputProps={{
              maxLength: 100,
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
              },
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
        <Grid item xs={5} sx={{ textAlign: "right" }}>
          <InputLabel>Description</InputLabel>
        </Grid>
        <Grid item xs={7}>
          {mode === "view" ? (
            <div
              className="wysiwyg-content"
              style={{
                backgroundColor: "white",
                padding: "16px",
                borderRadius: "4px",
                border: "1px solid rgba(0, 0, 0, 0.23)",
              }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(formik.values.description || ""),
              }}
            />
          ) : (
            <WysiwygEditor
              value={formik.values.description || ""}
              onChange={(text, html) => {
                addBreadcrumb("Activity description updated", {
                  category: "activity.edit",
                  level: "info",
                  data: {
                    hasHtml: html.includes("<a ") || html.includes("<strong>"),
                    htmlLength: html.length,
                  },
                });
                formik.setFieldValue("description", html);
              }}
              placeholder="Help your client understand why this activity is important."
            />
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
        <Grid item xs={5} sx={{ textAlign: "right" }}>
          <InputLabel>Video URL</InputLabel>
          <Typography variant="caption" sx={{ color: "#666", display: "block" }}>
            YouTube (watch/embed/youtu.be), Vimeo, or direct .mp4 link
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <TextField
            variant="outlined"
            fullWidth
            name="video_url"
            value={formik.values.video_url || ""}
            onChange={(e) => formik.setFieldValue("video_url", e.target.value || null)}
            onBlur={formik.handleBlur}
            placeholder="https://www.youtube.com/watch?v=..."
            error={hasVideoUrlError}
            helperText={
              hasVideoUrlError ? (
                formik.errors.video_url
              ) : showVideoUrlWarning ? (
                <Typography
                  component="span"
                  data-testid="video-url-warning"
                  sx={{ color: "#b76e00", fontSize: "0.75rem" }}
                >
                  {videoUrlWarning}
                </Typography>
              ) : (
                ""
              )
            }
            InputProps={{
              readOnly: mode === "view",
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
              },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ActivityBasicDetails;
